<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap justify-center align-center>
      <v-flex
        xs6
        body-1
      >
        <h3 class="title">Welcome to Aqua J Mutual Water Company </h3>
        <p> NEXT BUSINESS MEETING: Saturday, June 6, 2026 - 9am - 44639 95th ST E </p>
        <p>   All Landowners Welcome! </p>
        <h3>You must return your CCC (Cross Connection Control) Survey  by mail or email</h3>
        <p>   CCC Survey Links Below  </p>
        <material-download-card
          title=" Cross Connection Control Survey English"
          url="./img/2025 CCC Home Survey - English.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download CCC Survey in English "
        />
        <material-download-card
          title=" Cross Connection Control Survey Spanish"
          url="./img/2025 CCC Home Survey - Spanish.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download CCC Survey in Spanish "
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
